<template>
  <div class="flex flex-col gap-y-2">
    <div>
      <div class="ltr:font-sans text-sm flex flex-col gap-y-2">
        <p>{{ $t('NeedAnAppMsg1') }}</p>
        <p>{{ $t('NeedAnAppMsg2') }}</p>
      </div>
    </div>
    <div>
      <ol class="list-decimal ltr:font-sans text-sm flex flex-col gap-y-2 ps-8 pt-1">
        <li>{{ $t('NeedAnAppMsg3') }}</li>
        <li>
          <span>{{ $t('NeedAnAppMsg4') }}</span>
          <ol class="list-disc ltr:font-sans text-sm flex flex-col gap-y-2 ps-2 pt-1">
            <li>
              <p>
                {{ $t('googleAuthenticator') }}
                <span class="flex gap-x-3 pt-1.5">
                  <a
                    href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                    target="_blank"
                    class="text-primary hover:underline"
                  >
                    {{ $t('apple') }}
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
                    target="_blank"
                    class="text-primary hover:underline"
                  >
                    {{ $t('android') }}
                  </a>
                </span>
              </p>
            </li>
            <li>
              <p>
                {{ $t('microsoftAuthenticator') }}
                <span class="flex gap-x-3 pt-1.5">
                  <a
                    href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
                    target="_blank"
                    class="text-primary hover:underline"
                  >
                    {{ $t('apple') }}
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_US"
                    target="_blank"
                    class="text-primary hover:underline"
                  >
                    {{ $t('android') }}
                  </a>
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
